import type { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'
import { InfoTooltip } from '@ui/feedback'

export type CompactFieldProps = {
  label: string
  minWidth?: number
  tooltip?: TooltipContents
  children: ReactNode
}

export const CompactField = ({
  label,
  minWidth,
  tooltip,
  children,
}: CompactFieldProps): ReactElement => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
      minWidth,
      // Grow from a zero basis so the fields on each wrapped line share the full width equally;
      // minWidth (not the basis) decides where the line wraps.
      flex: '1 1 0%',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.25,
        minWidth: 0,
      }}
    >
      <Box
        component="span"
        sx={{
          fontSize: 11,
          color: 'text.secondary',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {label}
      </Box>
      {tooltip ? (
        <Box
          sx={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            '& .MuiSvgIcon-root': {
              fontSize: 12,
            },
          }}
        >
          <InfoTooltip {...tooltip} flex />
        </Box>
      ) : null}
    </Box>
    {children}
  </Box>
)
